import mapFinalCalculation, { RawFinalCalculation } from './mapFinalCalculation';
import mapProduct, { RawProduct } from './mapProduct';
import Reference from './Reference';
import SiMaxPrice from './SiMaxPrice';

export interface RawReference {
	dosageStrength: number | null;
	packageSize: number | null;
	referenceBasketVersion: string;
	referencedProductType: string;
	historicProductDataViewDate: string | null;
}

export interface RawSiMaxPrice {
	reference: RawReference;
	products: RawProduct[];
	finalCalculation: RawFinalCalculation;
	_links: { [key: string]: string };
}

export default function mapSiMaxPrice(siMaxPrice: RawSiMaxPrice): SiMaxPrice {
	return new SiMaxPrice(
		new Reference(
			siMaxPrice.reference.dosageStrength,
			siMaxPrice.reference.packageSize,
			siMaxPrice.reference.referenceBasketVersion,
			siMaxPrice.reference.referencedProductType,
			siMaxPrice.reference.historicProductDataViewDate !== null
				? new Date(siMaxPrice.reference.historicProductDataViewDate)
				: null
		),
		siMaxPrice.products.map(mapProduct),
		mapFinalCalculation(siMaxPrice.finalCalculation),
		siMaxPrice._links
	);
}
